import { isArray } from 'util';
import { ControlBuilder } from './control.builder';
import { ProcessAlarm } from '../process-alarm';

export class ProcessAlarmBuilder {
  static fromJson(json) {
    return (json)
      ? new ProcessAlarm(
        json.hash,
        json.description,
        json.pattern,
        ControlBuilder.fromJson(json.control)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ProcessAlarmBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/process-alarm.builder.ts